import PropTypes from 'prop-types';
import React from 'react';
import { browserHistory } from 'react-router';
import { compose } from 'recompose';
import { List } from 'immutable';
import { Button } from 'react-bootstrap';
import MainPage from '../../components/MainPage.react';

import bindReduceStore from '../../components/hocs/bindReduceStore.react';
import ResourceActions from '../../actions/ResourceActions';
import SecretActions from '../../actions/SecretActions';
import CurrentCredentialsStore from '../../stores/CurrentCredentialsStore';
import CurrentResourcesStore from '../../stores/CurrentResourcesStore';
import AdminStore from '../../stores/AdminStore';

import CredentialsList from './CredentialsList.react';

const CredentialTopButtons = () => (
  <div className='credential-buttons credential-buttons-top'>
    {AdminStore.getState().canAdministerResources &&
      <div className='credential-button'>
        <Button
          bsStyle='primary'
          onClick={() => browserHistory.push('credentials/resources')}
        >
          Manage Resources
        </Button>
      </div>
    }
    <div className='credential-button'>
      <Button
        className='add-secret-button'
        bsStyle='success'
        onClick={SecretActions.addEmptySecret}
      >
        Add Secret
      </Button>
    </div>
  </div>
);

class Credentials extends React.Component {
  componentDidMount() {
    ResourceActions.getResources();
    SecretActions.getSecrets();
  }

  render() {
    return (
      <MainPage>
        <h3>Credentials</h3>
        <CredentialTopButtons />
        <CredentialsList
          credentials={this.props.credentials}
          resources={this.props.resources}
        />
      </MainPage>
    );
  }
}

Credentials.propTypes = {
  credentials: PropTypes.instanceOf(List),
  resources: PropTypes.instanceOf(List),
};

export default compose(
  bindReduceStore(CurrentCredentialsStore, 'credentials'),
  bindReduceStore(CurrentResourcesStore, 'resources'),
)(Credentials);
